/* beautiful-react-hooks version: 0.27.4 */
var isDevelopment = process && process.env && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

export default isDevelopment;
